import {
    IPaymentActionData,
    ITopicHeaders,
    ITopicSubscription,
    MessageBroker,
    PaymentAppType,
    PostLoginActionNameEnum,
    PaymentChannel,
    SessionChannel,
    WalletChannel,
} from '@sparkware/uc-sdk-core';
import Container from 'typedi';
import { StorageItemEnum } from '../../../models/enums/storage-enums';
import { NativeUtils } from '../../native/native.utils';
import { SessionSimpleStoreService } from '../../storage/implementations/simple-store';

import {
    IOpenCashierUploadDocumentsPostLoginOptions,
    IPostLoginActionsState,
} from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';

const MB_HEADER: ITopicHeaders = { publisher: 'OpenCashierUploadDocumentsPostLoginAction' };

export class OpenCashierUploadDocumentsPostLoginAction extends PostLoginActionBase {
    private _appClosedSubscription: ITopicSubscription;
    private readonly _sessionChannel: SessionChannel;
    private readonly _paymentsChannel: PaymentChannel;
    private readonly _sessionSimpleStoreService: SessionSimpleStoreService;

    private readonly _walletChannel: WalletChannel;

    constructor(state: IPostLoginActionsState) {
        super(
            PostLoginActionNameEnum.OpenCashierUploadDocument,
            'OpenCashierUploadDocumentsPostLoginAction',
            state,
        );
        this._sessionChannel = MessageBroker.getInstance().session;
        this._paymentsChannel = MessageBroker.getInstance().payments;
        this._walletChannel = MessageBroker.getInstance().wallet;
        this._sessionSimpleStoreService = Container.get(SessionSimpleStoreService);

        this._appClosedSubscription = null;
    }

    protected override canExecute = (
        options?: IOpenCashierUploadDocumentsPostLoginOptions,
    ): Promise<boolean> => {
        const cashierOpenRequiredUploadDocument = options?.enabled;

        return Promise.resolve(cashierOpenRequiredUploadDocument);
    };

    protected override doAction = async (): Promise<boolean> => {
        await NativeUtils.showBottomBar(false);

        this.clearOptions();

        this._appClosedSubscription = this._sessionChannel.topics.appClosed.subscribe(
            this._onCashierClose,
        );
        const paymentsData: IPaymentActionData = {
            OnClose: this._onCashierClose,
            TabId: 20,
            AppType: PaymentAppType.FullCashier,
        };
        this._paymentsChannel.topics.CTA_Cashier_Open.publish(MB_HEADER, paymentsData);
        return false;
    };

    private _onCashierClose = () => {
        this.completeAction();

        if (!!this._appClosedSubscription) {
            this._appClosedSubscription.unsubscribe();
            this._appClosedSubscription = null;
        }

        const balancePolling =
            this._sessionSimpleStoreService.get(StorageItemEnum.BalancePollingRequired) === 'true';

        if (balancePolling) {
            this._walletChannel.topics.UpdateBalance.publish(MB_HEADER, {});
        }
    };
}
